export default __webpack_public_path__ + "static/media/menu-list_darkGray2.f2d666c1.svg";